import React from 'react';
import { useLanguage } from '../context/LanguageContext';

function Mission() {
  const { t } = useLanguage();

  return (
    <section id="mission" style={{ padding: '80px 0', backgroundColor: 'var(--bg-dark)' }}>
      <div className="container">
          <div className="checkerboard-content">
            <div className="checkerboard-text">
              <h2 className="section-title">{t.mission.title}</h2>
              <p className="mission-intro">
                <span>{t.mission.intro}</span>
              </p>
              <p className="mission-description">
                {t.mission.description}
              </p>
              
              <div className="mission-focus">
                <h3>{t.mission.focusTitle}</h3>
                <ul className="mission-list">
                  {t.mission.focusList.map((item, index) => (
                    <li key={index}>{item}</li>
                  ))}
                </ul>
              </div>

              <div className="principle-card">
                <h3>{t.mission.cardTitle}</h3>
                <p>{t.mission.cardText}</p>
              </div>
            </div>

            <div className="checkerboard-image">
              <div className="mission-image-placeholder">
                <img src="/images/mission.webp" alt="JKD Training" />
              </div>
            </div>
          </div>
      </div>
    </section>
  );
}

export default Mission;